import React from "react";
import "./Game_History.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Game_History_card from "./Game_History_card/Game_History_card";
import No_data from "../Common/No_data/No_data";

function Game_History() {

  const gameHistoryData = [
    {
      game: "Win Go",
      result: "Lose",
      resultClass: "lose",
      time: "2026-02-11 | 16:25:09",
      type: "Win Go 30s",
      period: "20260210100051197",
      order: "WG2026020806541699203201970865",
      select: "0",
      totalBet: "₹2.00",
      ballImage: "/assets/images/bet_Select_section/coint_3.png",
      tags: [
        { text: "Small", class: "small" },
        { text: "Green", class: "green" }
      ],
      actualAmount: "₹1.89",
      winnings: "₹0.00",
      fee: "₹0.04",
      profit: "-₹2.00",
      profitClass: "loss"
    },

      {
      game: "Win Go",
      result: "Win",
      resultClass: "win",
      time: "2026-02-12 | 11:20:09",
      type: "Win Go 30s",
      period: "20260210100051199",
      order: "WG2026020806541699203201999999",
      select: "5",
      totalBet: "₹5.00",
      ballImage: "/assets/images/bet_Select_section/coint_2.png",
      tags: [
        { text: "small", class: "small" },
        { text: "Red", class: "red" }
      ],
      actualAmount: "₹4.80",
      winnings: "₹8.00",
      fee: "₹0.10",
      profit: "+₹3.00",
      profitClass: ""
    },

    {
      game: "Win Go",
      result: "Win",
      resultClass: "win",
      time: "2026-02-12 | 11:20:09",
      type: "Win Go 30s",
      period: "20260210100051199",
      order: "WG2026020806541699203201999999",
      select: "5",
      totalBet: "₹5.00",
      ballImage: "/assets/images/bet_Select_section/coint_0.png",
      tags: [
        { text: "small", class: "small" },
        { text: "Red Purple", class: "red_purple" }
      ],
      actualAmount: "₹4.80",
      winnings: "₹8.00",
      fee: "₹0.10",
      profit: "+₹3.00",
      profitClass: ""
    }
  ];

  return (
    <section className="Game_History">

      <Common_white_header headingText={"Game History"} />

      <div className="container">

        {gameHistoryData.map((item, index) => (
          <Game_History_card key={index} data={item} />
        ))}
        
         <No_data/>
      </div>

    </section>
  );
}

export default Game_History;